// Language files index.ts

// Define an interface for a single language's messages
export interface LanguageMessages {
  [key: string]: string;
}

// Define an interface for the messages object that will hold all languages' messages
export interface AllLanguageMessages {
  [locale: string]: LanguageMessages;
}

// Define the available locales
const locales = ['en', 'zh', 'de', 'ar'];
export const FALL_BACK_LOCAL = 'en';

async function loadMessages(): Promise<AllLanguageMessages> {
  let messages: AllLanguageMessages = {};

  for (const locale of locales) {
    messages[locale] = await import(`../../locales/${locale}.json`);
  }

  return messages;
}

export default loadMessages;